import React, { useEffect } from 'react';
import ExercisePanel from 'containers/pages/person/programs/ExercisePanel';
import { useStore } from 'stores/Store';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import {
  ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_EDIT_EXERCISES,
  ROUTE_PERSONS_ENTITY_PERSON_PROGRAMS_ENTITY_PROGRAM_EXERCISE
} from 'routes/RouteList';
import { useContextMenu } from 'contexts/ContextMenuProvider';
import RemoveProgramButton from 'containers/partials/buttons/RemoveProgramButton';
import { FormattedMessage } from 'react-intl';
import messages from 'messages';
import { Button } from 'components/button';
import Icon from 'components/icon/Icon';
import DownloadExerciseProgramButton from 'containers/partials/buttons/DownloadExerciseProgramButton';

const PersonProgramExercisesTab = () => {
  const { push } = useHistory();
  const { entityId, groupId, personId, programId, exerciseId } = useParams();
  const program = useStore(state => state.program);
  const { setMenuItems, clearAllContext } = useContextMenu();

  useEffect(() => {
    const contextButtons = [];

    contextButtons.push(
      <EditProgramBtn />,
      <DeleteProgramBtn />,
      <DownloadExerciseProgramButton
        key={`download-exercise-program`}
        programId={programId}
      />
    );

    setMenuItems(contextButtons);
    return () => {
      clearAllContext();
    };
  }, [programId]);

  const DeleteProgramBtn = () => (
    <RemoveProgramButton
      key={`delete-program`}
      menu
      entityId={entityId}
      programId={programId}
    >
      <FormattedMessage {...messages.exercisesRemoveProgramButton} />
    </RemoveProgramButton>
  );

  const EditProgramBtn = () => (
    <Button
      key={`edit-program`}
      menu
      onClick={() =>
        push(
          generatePath(ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_EDIT_EXERCISES, {
            entityId,
            programId
          })
        )
      }
    >
      <FormattedMessage {...messages.exercisesEditProgramButton} />
      <Icon id="edit" />
    </Button>
  );

  const handleExerciseClick = exerciseId => {
    push(
      generatePath(
        ROUTE_PERSONS_ENTITY_PERSON_PROGRAMS_ENTITY_PROGRAM_EXERCISE,
        {
          entityId,
          groupId,
          personId,
          programId,
          exerciseId: exerciseId
        }
      )
    );
  };

  return (
    <ExercisePanel
      exercises={program.exercises}
      exerciseId={exerciseId}
      onClick={handleExerciseClick}
      exerciseGroup={program}
    />
  );
};

export default PersonProgramExercisesTab;
